import { ICONS_COMMON } from "@/common/icons/icons-common";

export const ICONS_MESSENGER = {
  Camera: (
    <svg width="28" height="24" viewBox="0 0 30 24" fill="none">
      <title>Camera</title>
      <path
        d="M20.59 3.68924L19.9521 2.54988C19.4159 1.59284 18.4043 1 17.3075 1H12.2636C11.1667 1 10.1552 1.59284 9.61895 2.54988L8.98106 3.68924C8.75714 4.08861 8.33546 4.3357 7.87774 4.3357H2.58291C1.70867 4.3357 1 5.04437 1 5.91862V20.919C1 21.7932 1.70867 22.5019 2.58291 22.5019H27.4171C28.2913 22.5019 29 21.7932 29 20.919V5.91862C29 5.04437 28.2913 4.3357 27.4171 4.3357H21.6929C21.2356 4.3357 20.8135 4.08861 20.59 3.68924Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9999 18.8043C18.0845 18.8043 20.5851 16.3037 20.5851 13.219C20.5851 10.1344 18.0845 7.63379 14.9999 7.63379C11.9152 7.63379 9.41461 10.1344 9.41461 13.219C9.41461 16.3037 11.9152 18.8043 14.9999 18.8043Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6407 9.25198C23.9186 9.25198 24.1439 9.02669 24.1439 8.74879C24.1439 8.47089 23.9186 8.24561 23.6407 8.24561C23.3628 8.24561 23.1375 8.47089 23.1375 8.74879C23.1375 9.02669 23.3628 9.25198 23.6407 9.25198Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Message: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M18 18.85H2C1.448 18.85 1 18.402 1 17.85V7.824C1 7.469 1.189 7.14 1.496 6.961L10 2L18.504 6.961C18.811 7.14 19 7.469 19 7.824V17.85C19 18.402 18.552 18.85 18 18.85Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M19 7.25L10 12.85L1 7.25V18.85H19V7.25Z" fill="white" />
    </svg>
  ),
  Warning: (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.687289 11C0.44082 11 0.213945 10.8683 0.0912263 10.6549C-0.0311487 10.4414 -0.0304612 10.1788 0.0936325 9.966L5.59363 0.341C5.71669 0.12994 5.94288 0 6.18729 0C6.43169 0 6.65788 0.12994 6.78129 0.341L12.2813 9.966C12.4054 10.1788 12.4061 10.4414 12.2837 10.6549C12.1613 10.8683 11.9334 11 11.6873 11H0.687289Z"
        transform="translate(0.669922 0.624023)"
        fill="#DD9717"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.54881C0 5.45634 0.0161562 5.37178 0.0491562 5.29237C0.0814692 5.214 0.127875 5.14594 0.187688 5.08887C0.246469 5.03112 0.319 4.98609 0.402187 4.95378C0.486062 4.92216 0.58025 4.90531 0.685437 4.90531C0.790625 4.90531 0.8855 4.92216 0.970062 4.95378C1.056 4.98609 1.12853 5.03112 1.18731 5.08887C1.24747 5.14594 1.29387 5.214 1.32584 5.29237C1.35884 5.37178 1.375 5.45634 1.375 5.54881C1.375 5.64162 1.35884 5.72619 1.32584 5.80319C1.29353 5.88053 1.24713 5.94722 1.18731 6.00531C1.12853 6.06238 1.056 6.10706 0.970062 6.14006C0.8855 6.17169 0.790625 6.1875 0.685437 6.1875C0.579906 6.1875 0.486063 6.17169 0.402187 6.13972C0.319 6.10672 0.246469 6.06203 0.187688 6.00497C0.127531 5.94687 0.0811252 5.88019 0.0491562 5.80284C0.0161562 5.72584 0 5.64128 0 5.54881ZM1.19625 4.125H0.174281L0.029562 0H1.34062L1.19625 4.125Z"
        transform="translate(6.16992 4.06152)"
        fill="white"
      />
    </svg>
  ),
  Timer: (
    <svg
      x="0px"
      y="0px"
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      enableBackground="new 0 0 26 26"
      fill="currentColor"
    >
      <g fill="currentColor">
        <path
          fill="currentColor"
          d="M11.001,12.997c-0.002,1.104,0.892,2.001,1.996,2.002c1.104,0,2-0.895,2.002-1.997   c0.002-1.106-0.893-2.001-1.996-2.001C11.898,10.999,11.002,11.891,11.001,12.997z"
        />
      </g>
      <g fill="currentColor">
        <path
          fill="currentColor"
          d="M13.573,13.538c0,0,0.001-0.002,0.001-0.004c0.39-0.39,1.101-1.715,0.72-2.053   c0,0-10.61-8.467-10.929-8.148s8.116,10.96,8.116,10.96C11.822,14.672,13.184,13.926,13.573,13.538z"
        />
      </g>
      <circle fill="currentColor" cx="13" cy="2" r="2.001" />
      <path
        fill="currentColor"
        d="M17.287,1.797c-0.688,1.154,0.396,1.861,0.723,2.04c3.244,1.776,5.453,5.21,5.453,9.163  c0,5.77-4.693,10.463-10.463,10.463S2.536,18.77,2.536,13c0-1.326,0.253-2.594,0.707-3.76c0.059-0.151,0.629-1.155-0.487-1.857  c-0.764-0.48-1.512,0.062-1.662,0.404C0.392,9.383,0,11.145,0,13c0,7.18,5.82,13,13,13s13-5.82,13-13  c0-5.113-2.959-9.528-7.253-11.646C18.657,1.309,17.768,0.99,17.287,1.797z"
      />
    </svg>
  ),
  Plus: ICONS_COMMON.Plus,
  Minus: ICONS_COMMON.Minus,
  VideoLength: (
    <svg width="9" height="10" viewBox="0 0 9 10" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.09204 0.102014L8.26044 4.37993C8.60286 4.58428 8.71479 5.02753 8.51044 5.36995C8.44911 5.47272 8.3632 5.55863 8.26044 5.61996L1.09204 9.89788C0.749615 10.1022 0.306364 9.99029 0.102013 9.64787C0.0352498 9.53599 0 9.40814 0 9.27786V0.72203C0 0.323264 0.323264 -1.8407e-07 0.72203 -1.8407e-07C0.852311 -1.8407e-07 0.980166 0.0352504 1.09204 0.102014Z"
        fill="white"
      />
    </svg>
  ),
  Emoji: (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <title>Emoji</title>
      <path
        d="M8 14.5C8 14.5 9.5 16.5 12 16.5C14.5 16.5 16 14.5 16 14.5M9 9H9.01M15 9H15.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Giphy: (
    <svg width="30" height="26" viewBox="0 0 30 26" fill="none">
      <title>GIF</title>
      <rect
        x="1"
        y="1"
        width="28"
        height="23.7143"
        rx="8"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M9.103 10.2699C10.066 10.1695 10.81 10.3422 11.076 10.4752C11.57 10.7222 12.17 10.522 12.417 10.028C12.664 9.534 12.464 8.9334 11.97 8.6864C11.267 8.3348 10.114 8.1537 8.896 8.2807C6.974 8.4811 5 10.1485 5 12.8744C5 15.6444 7.109 17.474 9.599 17.474C10.761 17.474 11.801 16.93 12.395 16.3686C12.918 15.8736 12.999 15.2142 12.999 14.8029L13 12.8748C13 12.6095 12.895 12.355 12.707 12.1674C12.52 11.9797 12.265 11.8744 12 11.8744L10.387 11.8746C9.834 11.8747 9.387 12.3225 9.387 12.8748C9.387 13.427 9.835 13.8747 10.387 13.8746L11 13.8745L10.999 14.8021C10.999 14.8449 10.997 14.8802 10.993 14.9085C10.991 14.9242 10.989 14.9366 10.987 14.946C10.696 15.2031 10.153 15.474 9.599 15.474C8.138 15.474 7 14.4655 7 12.8744C7 11.2391 8.133 10.3711 9.103 10.2699ZM17 9.2753C17 8.723 16.552 8.2753 16 8.2753C15.448 8.2753 15 8.723 15 9.2753V16.474C15 17.0263 15.448 17.474 16 17.474C16.552 17.474 17 17.0263 17 16.474V9.2753ZM20 8.2753C19.448 8.2753 19 8.723 19 9.2753V16.474C19 17.0263 19.448 17.474 20 17.474C20.552 17.474 21 17.0263 21 16.474V13.8688L23.006 13.8572C23.558 13.854 24.003 13.4037 24 12.8514C23.997 12.2992 23.546 11.854 22.994 11.8572L21 11.8688V10.2753H24C24.552 10.2753 25 9.8276 25 9.2753C25 8.723 24.552 8.2753 24 8.2753H20Z"
        fill="currentColor"
      />
    </svg>
  ),
  AI: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M501.824 32C303.552 32 141.504 176.992 141.504 357.76c0 23.712 2.816 47.104 8.32 69.856l-51.008 114.208a32 32 0 0 0 24.704 44.736c54.272 7.744 76.672 31.168 76.672 77.312v111.552a64 64 0 0 0 64 64h20.704a64 64 0 0 1 64 64V960a32 32 0 0 0 32 32h345.6a32 32 0 0 0 0-64h-313.6v-24.608a128 128 0 0 0-128-128h-20.736v-111.552c0-65.664-32.192-110.688-91.2-131.136l39.872-89.28a31.968 31.968 0 0 0 1.568-21.792 233.088 233.088 0 0 1-8.896-63.904c0-143.712 131.936-261.76 296.32-261.76s296.32 118.016 296.32 261.76a32 32 0 0 0 64 0C862.144 176.992 700.064 32 501.824 32zM904 448a32 32 0 0 0-32 32v360a32 32 0 0 0 64 0V480a32 32 0 0 0-32-32z" />
      <path d="M673.888 466.656c-11.744-25.568-48.416-24.64-58.816 1.536l-132.8 333.76a32 32 0 0 0 59.488 23.68l32.608-81.92c0.576 0.032 1.088 0.32 1.664 0.32h154.848l38.176 83.104a31.968 31.968 0 1 0 58.144-26.72l-153.312-333.76zM599.68 680l47.264-118.72 54.528 118.72H599.68z" />
    </svg>
  ),
  SaveNote: (
    <svg
      width="40"
      height="50"
      viewBox="0 0 40 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9436 26.2801L13.8891 32.2256L28.3403 17.7744"
        stroke="currentColor"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  EditNote: (
    <svg
      width="31"
      height="37"
      viewBox="0 0 31 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.58573 25.4143C8.62861 25.4572 8.80098 25.5001 8.97248 25.5001C9.60773 25.5001 10.7925 25.2104 11.363 24.9637C11.5056 24.9024 11.5424 24.7196 11.4321 24.6093L9.38198 22.5601C9.27786 22.4559 9.09673 22.4796 9.03548 22.6126C8.70648 23.3309 8.32673 25.1553 8.58573 25.4143Z"
        fill="currentColor"
      />
      <path
        d="M22.2426 12.9604L21.0403 11.7581C20.868 11.5857 20.6536 11.5 20.4383 11.5C20.224 11.5 20.0087 11.5857 19.8372 11.7572L10.2429 21.3096C10.158 21.3945 10.158 21.5319 10.2429 21.6167L12.3831 23.757C12.468 23.8419 12.6054 23.8419 12.6902 23.757L22.2426 14.1626C22.5856 13.8187 22.5856 13.3034 22.2426 12.9604Z"
        fill="currentColor"
      />
    </svg>
  ),
  DeleteNote: (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.8469 13H9.5816C9.78446 13 9.94895 12.8321 9.94895 12.625V5.875C9.94895 5.66791 9.78446 5.5 9.5816 5.5H8.8469C8.64404 5.5 8.47956 5.66791 8.47956 5.875V12.625C8.47956 12.8321 8.64404 13 8.8469 13ZM13.8673 2.5H11.3446L10.3037 0.728125C10.0381 0.276188 9.55947 -0.000249831 9.04313 1.69424e-07H5.9568C5.44068 -3.10806e-05 4.96239 0.276375 4.6968 0.728125L3.65537 2.5H1.13262C0.862098 2.5 0.642822 2.72384 0.642822 3V3.5C0.642822 3.77616 0.862098 4 1.13262 4H1.62241V14.5C1.62241 15.3284 2.28027 16 3.0918 16H11.9081C12.7197 16 13.3775 15.3284 13.3775 14.5V4H13.8673C14.1378 4 14.3571 3.77616 14.3571 3.5V3C14.3571 2.72384 14.1378 2.5 13.8673 2.5ZM5.90323 1.59094C5.93654 1.53434 5.99654 1.49981 6.06119 1.5H8.93874C9.0033 1.49994 9.06315 1.53444 9.09639 1.59094L9.63088 2.5H5.36905L5.90323 1.59094ZM11.9081 14.5H3.0918V4H11.9081V14.5ZM5.41833 13H6.15303C6.35589 13 6.52037 12.8321 6.52037 12.625V5.875C6.52037 5.66791 6.35589 5.5 6.15303 5.5H5.41833C5.21547 5.5 5.05099 5.66791 5.05099 5.875V12.625C5.05099 12.8321 5.21547 13 5.41833 13Z"
        fill="currentColor"
      />
    </svg>
  ),
  GalleryView: (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4H4V0H0V4ZM6 16H10V12H6V16ZM0 16H4V12H0V16ZM0 10H4V6H0V10ZM6 10H10V6H6V10ZM12 0V4H16V0H12ZM6 4H10V0H6V4ZM12 10H16V6H12V10ZM12 16H16V12H12V16Z"
        fill="currentColor"
      />
    </svg>
  ),
};
